import $ from 'jquery';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

import 'semantic-ui-calendar/dist/calendar';
import 'semantic-ui-calendar/dist/calendar.css';

var CallCenter = (function () {
  var loader = '<div class="ui active inline loader black-loader"></div>';
  var isLoading = false;
  var paginationLoading = false;

  var init = function () {
    $('.js__case-activity-select > .field').addClass('required');
    checkActivity($('.js__case-activity-select').find('input:checked').val());

    $('.js__case-activity-select')
      .find('input')
      .on('change', function () {
        checkActivity($(this).val());
      });

    $('.js__case-brand')
      .find('.dropdown')
      .dropdown({
        fullTextSearch: true,
        onChange: function (value) {
          var path = $('.js__case-brand').data('path');
          var url = path.replace('id', value);

          $.ajax({
            url: url,
            beforeSend: function () {
              $('.js__case-brand').find('.dropdown').addClass('disabled');
            },
            success: function (data) {
              $('.js__product-code-field').val(data.code);
            },
            complete: function () {
              $('.js__case-brand').find('.dropdown').removeClass('disabled');
            },
          });
        },
      });

    $('.js__call-search-modal').on('click', function () {
      var $url = $(this).data('url');

      $('.js__call-center-search')
        .modal({
          autofocus: false,
          observeChanges: true,
          keyboardShortcuts: false,
          onShow: function () {
            var $content = $('.js__modal-content.js__case-modal');
            var $searchResultContainer = $('.js__search-result-container');
            $searchResultContainer.focus();
            getContent($url, $content);
          },

          onHidden: function () {
            var $content = $('.js__modal-content');
            resetModal($content);
          },
        })
        .modal('show');
    });
  };

  function bindDeviceState() {
    $('body').on('click', '.device-item', function () {
      if (!isLoading) {
        isLoading = true;
        $('.device-item').addClass('loading');
        var url = $(this).data('brand-url');
        var codent = $(this).data('codentify');
        $(this).find('input').prop('checked', true);
        getBrandByDeviceId(url, codent);
        $('.device-item').each(function () {
          if ($(this).find('input').is(':checked')) {
            $(this).find('.device-image-container').addClass('active');
          } else {
            $(this).find('.device-image-container').removeClass('active');
          }
        });
      }
    });
  }

  function getBrandByDeviceId(path, codent) {
    $.get(path).done(function (res) {
      if (res.id) {
        $('.js__case-brand').find('.ui.dropdown').dropdown('set selected', res.id);
      }
      $('.js__codentify-field').val(codent);
      $('.device-item').removeClass('loading');
      isLoading = false;
    });
  }

  function checkActivity(elementVal) {
    if (elementVal === 'device') {
      $('.device-panel').transition('fade down');
      $('.replacement-checkbox').transition('fade down');

      new Swiper($('.js__device-slider-init').get(0), {
        modules: [Navigation],
        slidesPerView: 4,
        centerInsufficientSlides: true,
        speed: 400,
        navigation: {
          nextEl: '.js__device-button-next',
          prevEl: '.js__device-button-prev',
        },
        on: {
          init: function () {
            bindDeviceState();
          },
        },
      });
      bindDeviceState();
      $('.js__device-slider-init')[0].swiper.update();
    } else {
      $('.device-panel').transition('hide');
      $('.replacement-checkbox').transition('hide');
    }
  }

  function bindEvents() {
    $('.js__customers-and-contact-search-filter').on('click', function () {
      resetPagination();
      infinitScroll();
      getFilterResults(
        $('.js__call-center-search .js__customers-and-contact-search-filter-form'),
        $('.js__search-result-container'),
      );
    });

    $('.js__call-center-search .js__customers-and-contact-search-clear-filter').on('click', function (e) {
      $('.js__modal-content').html(loader);
      clearFilter($(e.currentTarget).data('reset-filter'), $('.js__modal-content'));
    });
  }

  function infinitScroll() {
    $('.client-search-results.js__search-result-container').scroll(function () {
      if ($(this)[0].offsetHeight + $(this)[0].scrollTop >= $(this)[0].scrollHeight && !paginationLoading) {
        var maxPage = $('.js__call-center-search #customer_contact_search_page').data('page-count');

        var getCurrentPage = $('.js__call-center-search #customer_contact_search_page').data('current-page');
        $('.js__call-center-search #customer_contact_search_page').val(parseInt(getCurrentPage) + 1);
        if (parseInt(getCurrentPage) < parseInt(maxPage)) {
          getNextPage($('.js__call-center-search .js__customers-and-contact-search-filter-form'));
        }
      }
    });
  }

  function resetPagination() {
    $('.js__call-center-search #customer_contact_search_page').data('current-page', 1);
    $('.js__call-center-search #customer_contact_search_page').val(1);
  }

  function getNextPage($form) {
    if (!paginationLoading) {
      paginationLoading = true;
      $.ajax({
        url: $form.attr('action'),
        method: $form.attr('method'),
        data: $form.serialize(),
        beforeSend: function () {
          $('.js__search-result-container').after(
            '<div class="paginationLoader" style="text-align: center;"><div style="margin: auto;" class="ui active inline loader black-loader"></div></div>',
          );
        },
        success: function (data) {
          $('.js__search-result-container tbody').append($(data).find('.js__list-container > tr'));
          paginationLoading = false;
          var currentPage = $('.js__call-center-search #customer_contact_search_page').data('current-page');
          $('.js__call-center-search #customer_contact_search_page').data('current-page', currentPage + 1);

          $('.paginationLoader').remove();
        },
      });
    }
  }

  function getContent($url, $container) {
    $.get($url).done(function (res) {
      $container.html(res);
      $('.ui.dropdown, select').dropdown();
      $('.ui.calendar').calendar({
        type: 'date',
        formatter: {
          date: function (date, settings) {
            if (!date) return '';
            var year = date.getFullYear();
            var month = String(date.getMonth() + 1).padStart(2, '0');
            var day = String(date.getDate()).padStart(2, '0');
            return year + '-' + month + '-' + day;
          },
        },
      });
      bindEvents();
      infinitScroll();
    });
  }

  function getFilterResults($form, $container) {
    $.ajax({
      url: $form.attr('action'),
      method: $form.attr('method'),
      data: $form.serialize(),
      beforeSend: function () {
        $form.addClass('loading');
      },
      success: function (data) {
        $container.html($(data));
      },
      complete: function () {
        $form.removeClass('loading');
        $('.ui.dropdown, select').dropdown();
        $('.ui.calendar').calendar({
          type: 'date',
          formatter: {
            date: function (date, settings) {
              if (!date) return '';
              var year = date.getFullYear();
              var month = String(date.getMonth() + 1).padStart(2, '0');
              var day = String(date.getDate()).padStart(2, '0');
              return year + '-' + month + '-' + day;
            },
          },
        });
        resetPagination();
        infinitScroll();
      },
    });
  }

  function clearFilter(url, container) {
    $.get(url).done(function (res) {
      container.html(res);
      $('.ui.dropdown, select').dropdown();
      bindEvents();
      $('.ui.calendar').calendar({
        type: 'date',
        formatter: {
          date: function (date, settings) {
            if (!date) return '';
            var day = date.getDate();
            var month = date.getMonth() + 1;
            var year = date.getFullYear();
            return year + '-' + month + '-' + day;
          },
        },
      });
      resetPagination();
      infinitScroll();
    });
  }

  function resetModal($container) {
    $container.html(loader);
  }

  return {
    init: init,
    bindDeviceState: bindDeviceState,
  };
})();

export default CallCenter;
